var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 152,
    viewBox: "0 0 251 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.374 65.0927C131.717 66.8805 131.216 68.5491 130.255 69.2907C130.927 69.9396 131.453 70.9328 131.677 72.1115C131.901 73.3431 131.743 74.5084 131.322 75.356C131.809 75.9784 132.191 76.8127 132.362 77.753C132.48 78.4151 132.428 79.17 132.217 79.9646C131.48 82.7059 129.07 84.6791 126.253 85.0102L104.935 87.8971L25.2627 130.288C16.8491 134.804 6.39464 131.295 2.35242 122.607C-1.63714 114.039 -1.36064 103.59 9.58102 98.4386",
    fill: "#F4EFFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.505 68.9861L114.89 70.999C112.928 71.2506 111.532 73.0517 111.782 75.0249C112.032 76.9981 113.836 78.3886 115.798 78.137L117.971 77.7132",
    fill: "#F4EFFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121.578 62.6692L114.732 63.7419C112.77 63.9935 111.374 65.7945 111.624 67.7678C111.874 69.741 113.678 71.1315 115.64 70.8799",
    fill: "#F4EFFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.243 75.3428L119.011 77.2498C117.049 77.5014 115.653 79.3024 115.904 81.2756C116.154 83.2489 117.958 84.6394 119.919 84.3878L126.951 83.5402",
    fill: "#F4EFFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.219 86.3741L108.622 87.3938L105.923 73.7667L111.914 64.3774L120.09 68.4563L116.219 86.3741Z",
    fill: "#B397F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M186.757 13.3838L119.519 81.5559C118.352 82.7397 118.359 84.6515 119.536 85.8259L159.647 125.846C160.824 127.021 162.725 127.013 163.893 125.829L231.131 57.657C232.298 56.4731 232.291 54.5614 231.114 53.3869L191.003 13.3666C189.826 12.1922 187.925 12.1999 186.757 13.3838Z",
    fill: "#3D1E80"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M186.558 17.0836L123.187 81.3352C122.019 82.519 122.027 84.4308 123.204 85.6052L159.837 122.156C161.014 123.33 162.915 123.323 164.083 122.139L227.454 57.8873C228.622 56.7035 228.614 54.7917 227.437 53.6173L190.803 17.0665C189.626 15.8921 187.726 15.8997 186.558 17.0836Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M175.5 2.14356L108.262 70.3156C107.095 71.4995 107.102 73.4113 108.279 74.5857L154.139 120.342C155.316 121.516 157.217 121.509 158.384 120.325L225.622 52.1526C226.79 50.9687 226.782 49.057 225.605 47.8825L179.746 2.12641C178.569 0.952 176.668 0.95969 175.5 2.14356Z",
    fill: "url(#paint0_linear_1_3011)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M209.205 40.1649L117.403 66.5364C115.809 66.9943 114.886 68.6655 115.341 70.2689L130.857 124.91C131.313 126.513 132.974 127.442 134.568 126.984L226.37 100.612C227.965 100.154 228.888 98.4833 228.433 96.8799L212.916 42.239C212.461 40.6356 210.799 39.707 209.205 40.1649Z",
    fill: "#3D1E80"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M207.232 43.2935L120.709 68.1483C119.115 68.6063 118.192 70.2774 118.647 71.8809L132.818 121.785C133.273 123.388 134.935 124.317 136.529 123.859L223.052 99.004C224.646 98.546 225.569 96.8749 225.114 95.2714L210.943 45.3676C210.487 43.7641 208.826 42.8355 207.232 43.2935Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M144.16 51.9555L186.583 8.95538L183.028 5.40625L140.605 48.4063C140.381 48.6315 140.605 49.0155 140.907 48.9361L144.581 47.9561L143.633 51.6509C143.554 51.9687 143.936 52.1806 144.16 51.9555Z",
    fill: "#1D254F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_3011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.836 24.8272L113.034 51.1986C111.44 51.6566 110.517 53.3277 110.972 54.9311L128.712 117.403C129.167 119.007 130.829 119.935 132.423 119.477L224.225 93.1059C225.819 92.648 226.743 90.9769 226.287 89.3734L208.547 26.9013C208.092 25.2978 206.43 24.3692 204.836 24.8272Z",
    fill: "#8258F3"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59424 98.4386L96.5218 64.1524C97.2855 63.861 97.9965 63.4373 98.6022 62.8811C101.262 60.5106 110.334 54.4055 112.651 54.1274C115.469 53.7831 127.609 56.1006 127.609 56.1006C129.847 56.4317 131.927 58.3652 131.585 60.6033C131.256 62.8413 129.215 63.914 126.977 63.5829L120.709 62.8678C118.273 62.5897 115.877 63.6624 114.442 65.6621C112.243 68.7345 108.477 73.0782 103.948 74.6144",
    fill: "#F4EFFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_3011",
    x: 86.8557,
    y: 8.71033,
    width: 163.548,
    height: 142.884,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.113725 0 0 0 0 0.145098 0 0 0 0 0.309804 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_3011"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_3011",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_3011",
    x1: 141.881,
    y1: 36.2296,
    x2: 192.29,
    y2: 85.9479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8258F3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.55101e1fb61fbd0a614e8b705c227d5d.svg";
export { ForwardRef as ReactComponent };